module.exports = __webpack_public_path__ + "img/11_non_open_L1.e83f5ef6.svg";